<p>
  ICONES
</p>

<em class="fa icon-user"></em>
<em class="fa icon-people"></em>
<em class="fa icon-user-female"></em>
<em class="fa icon-user-follow"></em>
<em class="fa icon-user-following"></em>
<em class="fa icon-user-unfollow"></em>
<em class="fa icon-login"></em>
<em class="fa icon-logout"></em>
<em class="fa icon-emotsmile"></em>
<em class="fa icon-phone"></em>
<em class="fa icon-call-end"></em>
<em class="fa icon-call-in"></em>
<em class="fa icon-call-out"></em>
<em class="fa icon-map"></em>
<em class="fa icon-location-pin"></em>
<em class="fa icon-direction"></em>
<em class="fa icon-directions"></em>
<em class="fa icon-compass"></em>
<em class="fa icon-layers"></em>
<em class="fa icon-menu"></em>
<em class="fa icon-list"></em>
<em class="fa icon-options-vertical"></em>
<em class="fa icon-options"></em>
<em class="fa icon-arrow-down"></em>
<em class="fa icon-arrow-left"></em>
<em class="fa icon-arrow-right"></em>
<em class="fa icon-arrow-up"></em>
<em class="fa icon-arrow-up-circle"></em>
<em class="fa icon-arrow-left-circle"></em>
<em class="fa icon-arrow-right-circle"></em>
<em class="fa icon-arrow-down-circle"></em>
<em class="fa icon-check"></em>
<em class="fa icon-clock"></em>
<em class="fa icon-plus"></em>
<em class="fa icon-minus"></em>
<em class="fa icon-close"></em>
<em class="fa icon-event"></em>
<em class="fa icon-exclamation"></em>
<em class="fa icon-organization"></em>
<em class="fa icon-trophy"></em>
<em class="fa icon-screen-smartphone"></em>
<em class="fa icon-screen-desktop"></em>
<em class="fa icon-plane"></em>
<em class="fa icon-notebook"></em>
<em class="fa icon-mustache"></em>
<em class="fa icon-mouse"></em>
<em class="fa icon-magnet"></em>
<em class="fa icon-energy"></em>
<em class="fa icon-disc"></em>
<em class="fa icon-cursor"></em>
<em class="fa icon-cursor-move"></em>
<em class="fa icon-crop"></em>
<em class="fa icon-chemistry"></em>
<em class="fa icon-speedometer"></em>
<em class="fa icon-shield"></em>
<em class="fa icon-screen-tablet"></em>
<em class="fa icon-magic-wand"></em>
<em class="fa icon-hourglass"></em>
<em class="fa icon-graduation"></em>
<em class="fa icon-ghost"></em>
<em class="fa icon-game-controller"></em>
<em class="fa icon-fire"></em>
<em class="fa icon-eyeglass"></em>
<em class="fa icon-envelope-open"></em>
<em class="fa icon-envelope-letter"></em>
<em class="fa icon-bell"></em>
<em class="fa icon-badge"></em>
<em class="fa icon-anchor"></em>
<em class="fa icon-wallet"></em>
<em class="fa icon-vector"></em>
<em class="fa icon-speech"></em>
<em class="fa icon-puzzle"></em>
<em class="fa icon-printer"></em>
<em class="fa icon-present"></em>
<em class="fa icon-playlist"></em>
<em class="fa icon-pin"></em>
<em class="fa icon-picture"></em>
<em class="fa icon-handbag"></em>
<em class="fa icon-globe-alt"></em>
<em class="fa icon-globe"></em>
<em class="fa icon-folder-alt"></em>
<em class="fa icon-folder"></em>
<em class="fa icon-film"></em>
<em class="fa icon-feed"></em>
<em class="fa icon-drop"></em>
<em class="fa icon-drawer"></em>
<em class="fa icon-docs"></em>
<em class="fa icon-doc"></em>
<em class="fa icon-diamond"></em>
<em class="fa icon-cup"></em>
<em class="fa icon-calculator"></em>
<em class="fa icon-bubbles"></em>
<em class="fa icon-briefcase"></em>
<em class="fa icon-book-open"></em>
<em class="fa icon-basket-loaded"></em>
<em class="fa icon-basket"></em>
<em class="fa icon-bag"></em>
<em class="fa icon-action-undo"></em>
<em class="fa icon-action-redo"></em>
<em class="fa icon-wrench"></em>
<em class="fa icon-umbrella"></em>
<em class="fa icon-trash"></em>
<em class="fa icon-tag"></em>
<em class="fa icon-support"></em>
<em class="fa icon-frame"></em>
<em class="fa icon-size-fullscreen"></em>
<em class="fa icon-size-actual"></em>
<em class="fa icon-shuffle"></em>
<em class="fa icon-share-alt"></em>
<em class="fa icon-share"></em>
<em class="fa icon-rocket"></em>
<em class="fa icon-question"></em>
<em class="fa icon-pie-chart"></em>
<em class="fa icon-pencil"></em>
<em class="far fa-comment"></em>
<em class="fa icon-note"></em>
<em class="fa icon-loop"></em>
<em class="fa icon-home"></em>
<em class="fa icon-grid"></em>
<em class="fa icon-graph"></em>
<em class="fa icon-microphone"></em>
<em class="fa icon-music-tone-alt"></em>
<em class="fa icon-music-tone"></em>
<em class="fa icon-earphones-alt"></em>
<em class="fa icon-earphones"></em>
<em class="fa icon-equalizer"></em>
<em class="fa icon-like"></em>
<em class="fa icon-dislike"></em>
<em class="fa icon-control-start"></em>
<em class="fa icon-control-rewind"></em>
<em class="fa icon-control-play"></em>
<em class="fa icon-control-pause"></em>
<em class="fa icon-control-forward"></em>
<em class="fa icon-control-end"></em>
<em class="fa icon-volume-1"></em>
<em class="fa icon-volume-2"></em>
<em class="fa icon-volume-off"></em>
<em class="fa icon-calendar"></em>
<em class="fa icon-bulb"></em>
<em class="fa icon-chart"></em>
<em class="fa icon-ban"></em>
<em class="fa icon-bubble"></em>
<em class="fa icon-camrecorder"></em>
<em class="fa icon-camera"></em>
<em class="fa icon-cloud-download"></em>
<em class="fa icon-cloud-upload"></em>
<em class="fa icon-envelope"></em>
<em class="fa icon-eye"></em>
<em class="fa icon-flag"></em>
<em class="fa icon-heart"></em>
<em class="fa icon-info"></em>
<em class="fa icon-key"></em>
<em class="fa icon-link"></em>
<em class="fa icon-lock"></em>
<em class="fa icon-lock-open"></em>
<em class="fa icon-magnifier"></em>
<em class="fa icon-magnifier-add"></em>
<em class="fa icon-magnifier-remove"></em>
<em class="fa icon-paper-clip"></em>
<em class="fa icon-paper-plane"></em>
<em class="fa icon-power"></em>
<em class="fa icon-refresh"></em>
<em class="fa icon-reload"></em>
<em class="fa icon-settings"></em>
<em class="fa icon-star"></em>
<em class="fa icon-symbol-female"></em>
<em class="fa icon-symbol-male"></em>
<em class="fa icon-target"></em>
<em class="fa icon-credit-card"></em>
<em class="fa icon-paypal"></em>
<em class="fa icon-social-tumblr"></em>
<em class="fa icon-social-twitter"></em>
<em class="fa icon-social-facebook"></em>
<em class="fa icon-social-instagram"></em>
<em class="fa icon-social-linkedin"></em>
<em class="fa icon-social-pinterest"></em>
<em class="fa icon-social-github"></em>
<em class="fa icon-social-google"></em>
<em class="fa icon-social-reddit"></em>
<em class="fa icon-social-skype"></em>
<em class="fa icon-social-dribbble"></em>
<em class="fa icon-social-behance"></em>
<em class="fa icon-social-foursqare"></em>
<em class="fa icon-social-soundcloud"></em>
<em class="fa icon-social-spotify"></em>
<em class="fa icon-social-stumbleupon"></em>
<em class="fa icon-social-youtube"></em>
<em class="fa icon-social-dropbox"></em>
<em class="fa icon-social-vkontakte"></em>
<em class="fa icon-social-steam"></em>
